/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Device_General_DescriptionInputs */

const de_device_general_description = /** @type {(inputs: Device_General_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier sehen Sie alle Geräte, die mit Ihrem waipu.tv-Konto verbunden sind. Sie können auf bis zu 5 Geräten gleichzeitig angemeldet sein.`)
};

/** @type {(inputs: Device_General_DescriptionInputs) => LocalizedString} */
const en_device_general_description = de_device_general_description;

/**

* @param {Device_General_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const device_general_description = /** @type {((inputs?: Device_General_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_General_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_device_general_description(inputs)
	return en_device_general_description(inputs)
});